import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import useMatricula from "../../hooks/useMatricula";

const RowCourse = ({
    data
}) =>{
    return(

          <tr>
            
            <th  scope="row"> <strong>{data?.scurso}</strong> - {data?.dcurso}</th>

            <td  scope="row"> <strong>{data?.sequivalente}</strong> - {data?.dequivalente}</td>
            <td  scope="row"> {data?.sgrupo} </td>
            <td style={{ textAlign: "center" }}>
              {
                  <OverlayTrigger
                  placement='right'
                  overlay={
                  <Tooltip id={data?.gtipo}>
                      {data?.ctipo}
                  </Tooltip>
                  }
                  >
                  <button className={`
                  ms-3 fs-sm 
                  ${data?.gtipo ==='C' ? 'icon-com' : 
                  data?.gtipo==='E' ? 'icon-ele' :
                  data?.gtipo==='O' ? 'icon-obli' : ''}`}
                  >
  
                      <span  variant="secondary">{data?.gtipo}</span>{" "}
                  </button>
                  </OverlayTrigger>
              }
            </td>
            <td>{data?.dmodalidad}</td>
            <td>{data?.ncreditos}</td>
            <td>{data?.nhoras}</td>
          </tr>

    )
}
export default RowCourse;